import { create } from 'zustand'
import { Dimensions } from 'react-native';

const useTooltipStore = create((set) => ({
    left: 0,
    top: 0,
    width: 0,
    height: 0,
    isOpen: false,
    activeId: null,
    text: "",
    subtitle: "",
    open: (x, y, text, subtitle, id) => {
        const position = getTooltipPosition(x, y, text, subtitle);
        set(() => ({ ...position, isOpen: true, text, subtitle, activeId: id }))
    },
    close: () => set(() => ({ isOpen: false, text: "", subtitle: "", activeId: null })),
}))


function getTooltipPosition(clickX, clickY, text, subtitle) {
    const isLandscape = Dimensions.get("window").width > Dimensions.get("window").height;

    const margin = 10; // Margin from viewport edges
    const paddingHorizontal = 10; // Padding inside tooltip
    const paddingVertical = 5; // Padding inside tooltip
    const fontSize = 12; // Font size
    const subtitleFontSize = 11; // Subtitle font size
    const viewportWidth = isLandscape ? (Dimensions.get("window").width) : Dimensions.get("window").width;
    const maxWidth = Math.min(400, viewportWidth - (2 * margin));

    // Use the longer of text/subtitle to estimate width — subtitle is often longer
    const longestLine = (subtitle && subtitle.length > text.length) ? subtitle : text;
    const longestFontSize = (subtitle && subtitle.length > text.length) ? subtitleFontSize : fontSize;

    // Estimate tooltip width based on character count
    const charWidth = longestFontSize * (longestLine.length > 100 ? 0.4 : (longestLine.length > 50 ? 0.5 : (longestLine.length > 25 ? 0.55 : 0.6)));
    const estimatedWidth = longestLine.length * charWidth + paddingHorizontal * 2;

    // Ensure tooltip width does not exceed max width
    const tooltipWidth = Math.min(estimatedWidth, maxWidth);

    // Estimate height: If width is limited, assume multi-line text
    const textLineCount = Math.ceil((text.length * fontSize * 0.6) / maxWidth);
    const subtitleLineCount = subtitle ? Math.ceil((subtitle.length * subtitleFontSize * 0.55) / maxWidth) : 0;
    const tooltipHeight = (fontSize * 1.6 * Math.max(1, textLineCount) + paddingVertical * 2) + (subtitle ? subtitleFontSize * 1.4 * Math.max(1, subtitleLineCount) + 2 : 0);

    let posX = clickX - tooltipWidth / 2; // Center on anchor point
    let posY = clickY - tooltipHeight - margin; // Default: Position above the click

    // If tooltip goes above the viewport, place it below instead
    if (posY < margin) {
        posY = clickY + margin;
    }

    // Adjust if tooltip overflows right edge
    if (posX + tooltipWidth + margin > viewportWidth) {
        posX = viewportWidth - tooltipWidth - margin;
    }

    // Ensure tooltip doesn't go off the left edge
    posX = Math.max(margin, posX);

    return { left: posX, top: posY, width: tooltipWidth, height: tooltipHeight };
}

export default useTooltipStore